import module from 'finanzas/module.js'

const schema = {
  captura_fecha: 'datetime',
  id_lote: 'number',
  movimientos: 'number',
  eliminar: 'boolean',
}

class FinancesCargarMovimientosBancariosHistorialService {
  constructor ($http, $filter) {
    this.$http = $http
    this.$filterDate = $filter('date')
  }

  get (fecha) {
    return this.$http.get('/api/finanzas/carga_movimientos/historial', {
      params: {fecha: this.$filterDate(fecha, 'yyyy-MM-dd')},
      schema: schema,
    })
  }

  delete (idLote) {
    return this.$http.delete('/api/finanzas/carga_movimientos/historial', {
      params: {lote_id: idLote},
      schema: {lote_id: 'number'},
    })
  }
}

module.service('FinancesCargarMovimientosBancariosHistorial', FinancesCargarMovimientosBancariosHistorialService)



// WEBPACK FOOTER //
// ./src/finanzas/services/CargarMovimientosBancariosHistorial.js